<script>
  // ══════════════════════════════════════════════════════════════════════════
  // РАЗВЛЕЧЕНИЯ: Колесо удачи · Сапёр — перенос games.tsx 1:1.
  // Колесо — 20 секторов, коэффициенты 2/3/5/10; сапёр — поле и мины держит
  // СЕРВЕР, интерфейс только рисует его ответ.
  // ══════════════════════════════════════════════════════════════════════════
  import { t } from '../../i18n.js';
  import { money, num } from '../partsfn.js';
  import Ico from '../ico.svelte';
  import Scroll from '../ui/scroll.svelte';
  import Sechead from '../ui/sechead.svelte';
  import Panel from '../ui/panel.svelte';
  import Metric from '../ui/metric.svelte';
  import Mgrid from '../ui/mgrid.svelte';
  import Chip from '../ui/chip.svelte';
  import GoldBtn from '../ui/goldbtn.svelte';
  import GhostBtn from '../ui/ghostbtn.svelte';
  import Row from '../ui/row.svelte';
  import Rows from '../ui/rows.svelte';
  import Line from '../ui/line.svelte';
  import Input from '../ui/input.svelte';

  export let part = 'wheel';
  export let wheel = {};
  export let sapper = undefined;
  export let balance = 0;
  export let nui = () => {};

  // ── Колесо
  const W_HEX = { white: '#e8e4dc', red: '#d1483f', green: '#4fae63', yellow: '#e0a83e' };
  const W_COEF = { white: 2, red: 3, green: 5, yellow: 10 };
  const W_COLORS = Object.keys(W_COEF);
  // Раскладка 20 секторов — как в геймоде: белого больше всего, жёлтый один.
  const SECTORS = [
    'white', 'red', 'white', 'green', 'white', 'red', 'white', 'yellow', 'white', 'red',
    'white', 'green', 'white', 'red', 'white', 'green', 'white', 'red', 'white', 'red',
  ];
  const BET_MIN = 100, BET_MAX = 1000000;

  let bet = '1000';
  let pick = null;
  $: wstats = wheel.stats ?? {};
  $: wbets = wheel.bets ?? {};

  // Сектор колеса — путь-клин. Радиус 96, центр 100/100 (viewBox 200×200).
  const wedge = (i) => {
    const step = 360 / SECTORS.length;
    const a0 = ((i * step - 90) * Math.PI) / 180, a1 = (((i + 1) * step - 90) * Math.PI) / 180;
    const x0 = 100 + 96 * Math.cos(a0), y0 = 100 + 96 * Math.sin(a0);
    const x1 = 100 + 96 * Math.cos(a1), y1 = 100 + 96 * Math.sin(a1);
    return `M100 100 L${x0.toFixed(2)} ${y0.toFixed(2)} A96 96 0 0 1 ${x1.toFixed(2)} ${y1.toFixed(2)} Z`;
  };

  const place = () => {
    const v = Math.max(BET_MIN, Math.min(BET_MAX, Number(bet) || 0));
    if (pick) nui('wheelBet', { bet: v, color: pick });
  };

  // ── Сапёр
  const COEF = [1.1, 1.2, 1.4, 1.6, 2, 2.5, 3];
  const SP_MIN = 100, SP_MAX = 500000;

  let sbet = '1000';
  // ответ сервера помечает открытые клетки; взорвавшуюся мину подсвечиваем отдельно
  let opened = {};
  $: sstate = sapper?.state ?? 'idle';
  $: srow = sstate === 'play' ? (sapper?.row ?? 0) : -1;
  $: scoef = sapper?.coef?.length ? sapper.coef : COEF;
  $: cellsInRow = sapper?.cells ?? 5;
  $: stake = Math.max(SP_MIN, Math.min(SP_MAX, Number(sbet) || 0));
  $: playBet = sapper?.bet || stake;
  $: swin = srow > 0 ? Math.round(playBet * scoef[srow - 1]) : 0;

  // перенос useEffect: idle → чистим поле; lose → помечаем мину
  let _sapKey = '';
  $: {
    const k = sstate + ':' + (sapper?.mine ?? '') + ':' + (sapper?.row ?? '');
    if (k !== _sapKey) {
      _sapKey = k;
      if (sstate === 'idle') opened = {};
      else if (sstate === 'lose' && sapper?.mine != null && sapper.mine >= 0)
        opened = { ...opened, [(sapper.row ?? 0) + ':' + sapper.mine]: 'miss' };
    }
  }

  const start = () => { opened = {}; nui('sapperBet', { bet: stake }); };
  const cash = () => nui('sapperCash', {});
  const pickCell = (r, c) => {
    if (r !== srow) return;
    opened = { ...opened, [r + ':' + c]: 'hit' };   // сервер поправит, если там мина
    nui('sapperPick', { row: r, cell: c });
  };
</script>

{#if part === 'wheel'}
  <Scroll>
    <Sechead kicker={t('m.wh.kicker')} title={t('m.wh.title')}>
      <svelte:fragment slot="meta">{t('m.wh.round')} <b>#{num(wheel.round)}</b></svelte:fragment>
    </Sechead>
    <div class="mn-split" style="align-items:stretch">
      <div class="r">
        <Panel>
          <Row style="align-items:center;gap:22px">
            <div class="mn-wheel">
              <svg viewBox="0 0 200 200">
                {#each SECTORS as c, i (i)}
                  <path d={wedge(i)} fill={W_HEX[c]} stroke="rgba(0,0,0,0.35)" stroke-width="0.8" />
                {/each}
                <circle cx="100" cy="100" r="34" fill="#100d0a" stroke="rgba(224,168,62,0.45)" stroke-width="1.5" />
                <text x="100" y="106" text-anchor="middle" style="font:800 20px 'Unbounded', sans-serif;fill:#e0a83e">
                  {wheel.spinning ? '···' : num(wheel.timeLeft)}
                </text>
              </svg>
              <div class="needle"></div>
            </div>

            <div class="ui-grow">
              <div class="ui-sechead" style="margin-bottom:12px">
                <div class="kick">{t('m.wh.round')} #{num(wheel.round)}</div>
                <div class="row">
                  <div class="ttl">{wheel.spinning ? t('m.wh.spinning') : t('m.wh.waiting')}</div>
                </div>
              </div>
              <div class="ui-field" style="margin-bottom:16px">
                <span class="lab">{t('m.wh.history')}</span>
                <div class="mn-hist">
                  {#each wheel.history ?? [] as h, i (i)}<i style="background:{W_HEX[h]}"></i>{/each}
                </div>
              </div>
              <div class="ui-field" style="max-width:260px">
                <span class="lab">{t('m.wh.bet')}</span>
                <Input numeric value={bet} placeholder={String(BET_MIN)} onInput={(v) => (bet = v.replace(/\D/g, ''))} />
                <div class="hint">{num(BET_MIN)} — {num(BET_MAX)} JC · {t('m.balance')}: {num(balance)} JC</div>
              </div>
            </div>
          </Row>

          <!-- четыре цвета = четыре ставки; активная подсвечена золотой рамкой -->
          <div class="mn-grid" style="margin-top:14px;grid-template-columns:repeat(4, 1fr)">
            {#each W_COLORS as c (c)}
              {@const s = wstats[c] ?? { players: 0, bank: 0 }}
              <div class={'mn-bet' + (pick === c ? ' on' : '')} on:click={() => (pick = c)}>
                <span class="cf" style="color:{W_HEX[c]}">{W_COEF[c]}×</span>
                <span class="mt">{t('m.wh.players')}: {num(s.players)}</span>
                <span class="mt">{t('m.wh.bank')}: {num(s.bank)} JC</span>
              </div>
            {/each}
          </div>

          <div style="margin-top:14px">
            {#if pick}
              <GoldBtn block on:click={place}><Ico n="wheel" s={16} />{t('m.wh.place')} · {W_COEF[pick]}×</GoldBtn>
            {:else}
              <GhostBtn block disabled style="opacity:0.45;cursor:default">{t('m.wh.place')}</GhostBtn>
            {/if}
          </div>
        </Panel>
      </div>

      <div class="l">
        <Panel>
          <Sechead title={t('m.wh.bank')} divider={false} />
          {#each W_COLORS as c (c)}
            {@const list = wbets[c] ?? []}
            <div style="margin-bottom:14px">
              <div class="ui-field" style="margin-bottom:6px">
                <div class="labrow">
                  <span class="lab" style="margin-bottom:0;color:{W_HEX[c]}">{W_COEF[c]}×</span>
                  <span class="note mn-num">{num((wstats[c] ?? { bank: 0 }).bank)} JC</span>
                </div>
              </div>
              {#if list.length === 0}
                <div class="hint">{t('m.wh.noBets')}</div>
              {:else}
                <Rows>{#each list as b, i (i)}<Line k={b.name} v={num(b.amount) + ' JC'} />{/each}</Rows>
              {/if}
            </div>
          {/each}
        </Panel>
      </div>
    </div>
  </Scroll>

{:else}
  <Scroll>
    <Sechead kicker={t('m.sp.kicker')} title={t('m.sp.title')}>
      <svelte:fragment slot="meta">{t('m.balance')}: <b>{num(balance)} JC</b></svelte:fragment>
    </Sechead>
    <div class="mn-split">
      <div class="r">
        <Panel>
          <div class="mn-mine">
            {#each scoef as k, r (r)}
              <div class={'mn-mrow' + (r === srow ? ' now' : '')}>
                <span class="cf">{k.toFixed(1)}×</span>
                {#each Array.from({ length: cellsInRow }, (_, c) => c) as c (c)}
                  {@const st = opened[r + ':' + c]}
                  <div class={'mn-mcell' + (st ? ' ' + st : '')} on:click={() => pickCell(r, c)}>
                    {#if st === 'hit'}<Ico n="check" s={16} />{:else if st === 'miss'}<Ico n="close" s={16} />{/if}
                  </div>
                {/each}
              </div>
            {/each}
          </div>
          <div class="hint" style="margin-top:14px">{t('m.sp.rule')}</div>
        </Panel>
      </div>

      <div class="l">
        <Panel>
          <Sechead title={t('m.sp.title')} divider={false} />
          <Mgrid>
            <Metric gold label={t('m.sp.win')} value={num(sstate === 'win' ? (sapper?.win ?? 0) : swin) + ' JC'} smallValue />
            <Metric label={t('m.sp.row')} value={srow < 0 ? '—' : `${srow + 1} / ${scoef.length}`} smallValue />
          </Mgrid>
          <div class="ui-field" style="margin-top:12px">
            <span class="lab">{t('m.wh.bet')}</span>
            <Input numeric value={sbet} disabled={srow >= 0} onInput={(v) => (sbet = v.replace(/\D/g, ''))} />
            <div class="hint">{num(SP_MIN)} — {num(SP_MAX)}</div>
          </div>
          <div class="ui-col" style="margin-top:12px">
            {#if srow < 0}
              <GoldBtn block on:click={start}><Ico n="play" s={15} />{t('m.sp.play')}</GoldBtn>
            {:else}
              <GoldBtn block on:click={cash} disabled={srow === 0} style={srow === 0 ? 'opacity:0.5' : undefined}>
                {t('m.sp.cashout')} · {num(swin)} JC
              </GoldBtn>
            {/if}
            {#if sstate === 'lose'}<Chip tone="neg">{t('m.sp.boom')}</Chip>{/if}
            {#if srow >= 0}<Chip>{t('m.sp.row')} {srow + 1}</Chip>{/if}
          </div>
        </Panel>
      </div>
    </div>
  </Scroll>
{/if}
